export default "<app-nav-shell></app-nav-shell>"